import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import Classes from '../Classes';
import InlineLoginError from './InlineLoginError';
import TranslationService from '../../translations';

const ErrorContainer = ({ errors = [] }) => {
  const notLoggedIn = Array.isArray(errors) ? errors.find((error) => error.code === 'unauthorized') : null;
  if (notLoggedIn) {
    const translations = TranslationService.getTranslations(errors[0].locale);
    return (<InlineLoginError translations={translations} mustLogIn />);
  }
  const adminOnlyUser = Array.isArray(errors) ? errors.find((error) => error.code === 'admin') : null;
  return (
    <div data-testid="Error-Container">
      { Array.isArray(errors) ? errors.map((error) => (error
        ? (
          <Alert key={`${error.code} ${error.message}`} bsStyle={Classes.danger}>
            { adminOnlyUser ? <i data-testid="admin-only-user-error" className={Classes.icons.adminWarning} /> : null }
            {error.message}
          </Alert>
        ) : null)) : null}
    </div>
  );
};

ErrorContainer.propTypes = {
  errors: PropTypes.array.isRequired
};

export default ErrorContainer;
